import React from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { ChartContainer } from '../../../../../shared/components/charts/ChartContainer';

interface ICohortAgeDistributionChartProps {
	data: any;
}

const CohortAgeDistributionChart: React.FC<ICohortAgeDistributionChartProps> = ({ ...props }) => {
	const options: AgChartOptions = {
		data: props.data,
		series: [
			{
				type: 'bar',
				xKey: 'age',
				yKey: 'imoCount',
				yName: '# Ships',
				xName: 'Year(s) Old',
				fill: '#1f2937', // Dark blue color
			},
		],
		axes: [
			{
				type: 'category',
				position: 'bottom',
				label: {
					rotation: 0,
				},
				title: {
					text: 'Year(s) Old',
				},
			},
			{
				type: 'number',
				position: 'left',
				title: {
					text: '# Ships',
				},
			},
		],
		legend: {
			enabled: false,
		},
	};

	return (
		<ChartContainer
			data={options.data}
			filename="cohort_age_distribution_data"
			buttonPosition="top-right"
		>
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default CohortAgeDistributionChart;
